import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Is mesotherapy painful?',
    a: 'We use ultra-fine micro-needles and apply a medical-grade numbing cream prior to the treatment. Most patients describe the sensation as a mild tingling or scratching, finding it highly tolerable.'
  }, {
    q: 'How is Korean Mesotherapy different from filler?',
    a: 'Unlike dermal fillers which add physical volume to change the shape of your face, mesotherapy delivers liquid nutrients (vitamins, non-crosslinked hyaluronic acid, peptides) to improve skin quality, hydration, and cellular function without altering your features.'
  }, {
    q: 'What ingredients are in the cocktail?',
    a: 'Each cocktail is customized, but typically includes a base of pure, uncrosslinked hyaluronic acid combined with essential vitamins (A, B, C, E), amino acids, coenzymes, and peptides designed to stimulate collagen and deeply hydrate.'
  }, {
    q: 'How many sessions will I need?',
    a: "For optimal 'glass skin' results, we typically recommend an initial series of 3 to 4 sessions spaced 2 to 4 weeks apart, followed by maintenance sessions every 3 to 6 months depending on your skin's needs."
  }, {
    q: 'Can I combine this with other treatments?',
    a: 'Yes. Mesotherapy pairs beautifully with treatments like Botox, laser therapies, or mild peels. During your consultation, we will design a cohesive treatment plan tailored to your specific goals.'
  }];
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-32 bg-cream-dark/20 border-t border-divider" data-id="element-107">
      <div className="container mx-auto px-4 md:px-6" data-id="element-108">
        <div className="max-w-3xl mx-auto" data-id="element-109">
          <FadeIn data-id="element-110">
            <h2 className="text-3xl md:text-4xl font-serif text-center text-primary mb-12 md:mb-16" data-id="element-111">
              Frequently Asked Questions
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-112">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 100} data-id="element-113">
                <div className="border border-divider rounded-lg bg-white overflow-hidden transition-all duration-300 hover:border-gold/30" data-id="element-114">
                  <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => toggleAccordion(index)} aria-expanded={openIndex === index} data-id="element-115">
                    <span className="font-serif text-lg md:text-xl font-medium text-primary pr-8" data-id="element-116">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`flex-shrink-0 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-117" />
                  </button>

                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-118">
                    <p className="text-foreground/70 leading-relaxed pt-2 border-t border-divider/50" data-id="element-119">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}